import * as R from 'ramda';

export interface ProcessType {
  id: string;
  description: string;
}

type IsProcessType = (processType: ProcessType) => boolean;
export const isPathAlteration: IsProcessType = R.propEq('id', 'E');
export const isPathModification: IsProcessType = R.propEq('id', 'M');
const isPreArrangedPath: IsProcessType = R.propEq('id', 'P');
const isCatalog: IsProcessType = R.propEq('id', 'C');
export const isAnyCatalog: IsProcessType = R.anyPass([isPreArrangedPath, isCatalog]);
